"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TimeInput = void 0;
var lodash_isnumber_1 = __importDefault(require("lodash.isnumber"));
var react_1 = __importDefault(require("react"));
var BaseInput_1 = require("./common/BaseInput");
function TimeInput(_a) {
    var hours = _a.hours, minutes = _a.minutes, onChange = _a.onChange, size = _a.size;
    var handleChange = function (nextValue) {
        var _a = nextValue.split(':').map(function (part) { return parseInt(part, 10); }), newHours = _a[0], newMinutes = _a[1];
        if (isValidHour(newHours) && isValidMinute(newMinutes)) {
            onChange({ hours: newHours, minutes: newMinutes });
        }
    };
    var value = isValidHour(hours) && isValidMinute(minutes) ? format(hours, minutes) : '';
    return (react_1.default.createElement(BaseInput_1.BaseInputWrapper, { size: size },
        react_1.default.createElement(BaseInput_1.BaseInput, { onChange: handleChange, type: 'time', value: value })));
}
exports.TimeInput = TimeInput;
function format(hours, minutes) {
    return "".concat(String(hours).padStart(2, '0'), ":").concat(String(minutes).padStart(2, '0'));
}
function isValidHour(hour) {
    return (0, lodash_isnumber_1.default)(hour) && hour >= 0 && hour < 24 && hour % 1 === 0;
}
function isValidMinute(minutes) {
    return (0, lodash_isnumber_1.default)(minutes) && minutes >= 0 && minutes < 60 && minutes % 1 === 0;
}
